import styled from 'styled-components';

export const StepContainer = styled.div`
  padding: 0;
  background-color: ${(props: any) => props.theme.colors.interfacePure0};
  border-radius: 8px;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: ${(props: any) => props.theme.colors.c1a202c};
  margin: 0 0 8px 0;
`;

export const SectionDescription = styled.p`
  font-size: 0.875rem;
  color: ${(props: any) => props.theme.colors.c718096};
  margin: 0 0 16px 0;
`;

export const FieldsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label<{ required?: boolean }>`
  font-size: 12px;
  color: ${(props: any) => props.theme.colors.c1a202c};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &::after {
    content: '${(p) => (p.required ? " *" : "")}';
    color: ${(props: any) => props.theme.colors.primaryRed400};
  }
`;

export const InputDisplay = styled.input<{ hasError?: boolean }>`
  width: 100%;
  height: 48px;
  background: ${(props: any) => props.theme.colors.white};
  border: 1px solid ${(p) => (p.hasError ? 'var(--ce52940)' : 'var(--ceaeef3)')};
  outline: none;
  border-radius: 8px;
  color: ${(props: any) => props.theme.colors.interfaceText500};
  padding: 12px 16px;
  font-size: 16px;
  line-height: 24px;
`;

export const DateTimeFieldContainer = styled.div<{ hasError?: boolean }>`
  position: relative;
  width: 100%;
  height: 48px;
  background: ${(props: any) => props.theme.colors.white};
  border: 1px solid ${(p) => (p.hasError ? 'var(--ce52940)' : 'var(--ceaeef3)')};
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:focus-within {
    border-color: ${(props: any) => props.theme.colors.interfaceGray400};
  }
`;

export const DateTimeInput = styled.input`
  flex: 1;
  height: 100%;
  background: transparent;
  border: none;
  outline: none;
  color: ${(props: any) => props.theme.colors.interfaceText500};
  padding: 12px 16px;
  font-size: 16px;
  line-height: 24px;
  font-family: inherit;
  cursor: pointer;

  &::placeholder {
    color: ${(props: any) => props.theme.colors.c9ca3af};
  }
`;

export const TimezoneDivider = styled.div`
  width: 1px;
  height: 24px;
  background: ${(props: any) => props.theme.colors.ce2e8f0};
  margin: 0 8px;
`;

export const TimezoneDisplay = styled.div`
  padding: 0 16px 0 0;
  color: ${(props: any) => props.theme.colors.c6b7280};
  font-size: 16px;
  font-weight: 400;
  font-family: inherit;
  user-select: none;
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  color: ${(props: any) => props.theme.colors.c9ca3af};
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
  user-select: none;
  margin-right: 8px;
  position: relative;
  z-index: 10;

  &:hover {
    color: ${(props: any) => props.theme.colors.c6b7280};
  }

  &:active {
    color: ${(props: any) => props.theme.colors.c374151};
  }
`;

export const ErrorMessage = styled.div`
  color: ${(props: any) => props.theme.colors.primaryRed400};
  font-size: 12px;
`;

export const TextArea = styled.textarea<{ hasError?: boolean }>`
  width: 100%;
  height: 310px;
  background: ${(props: any) => props.theme.colors.white};
  border: 1px solid ${(p) => (p.hasError ? 'var(--ce52940)' : 'var(--ceaeef3)')};
  outline: none;
  border-radius: 8px;
  color: ${(props: any) => props.theme.colors.interfaceText500};
  padding: 12px 16px;
  font-size: 16px;
  line-height: 24px;
  font-family: inherit;
  resize: none;
  transition: all 0.2s ease;

  &:focus {
    border-color: ${(props: any) => props.theme.colors.interfaceGray400};
  }

  &::placeholder {
    color: ${(props: any) => props.theme.colors.c9ca3af};
  }
`;

export const FilesContainer = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 8px;
  padding: 16px;
  height: 310px;
  transition: all 0.2s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const UploadIcon = styled.div`
  color: ${(props: any) => props.theme.colors.primaryRed400};
  font-size: 16px;
  font-weight: bold;
`;

export const UploadText = styled.span`
  color: ${(props: any) => props.theme.colors.primaryRed400};
  font-weight: 600;
  font-size: 14px;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};
`;

export const LeftButtons = styled.div`
  display: flex;
  gap: 12px;
`;

export const RightButtons = styled.div`
  display: flex;
  gap: 12px;
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};

  ${(p) => p.variant === 'primary' ? `
    background-color: ${(props: any) => props.theme.colors.primaryRed400};
    color: ${(props: any) => props.theme.colors.pureWhite};
    border-color: ${(props: any) => props.theme.colors.primaryRed400};

    &:hover {
      background-color: ${(props: any) => props.theme.colors.cd41e35};
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(229, 41, 64, 0.3);
    }
  ` : `
    background-color: ${(props: any) => props.theme.colors.interfacePure0};
    color: ${(props: any) => props.theme.colors.c4a5568};

    &:hover {
      background-color: ${(props: any) => props.theme.colors.cf7fafc};
      border-color: ${(props: any) => props.theme.colors.ccbd5e0};
    }
  `}
`;

export const FilesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props: any) => props.theme.colors.cf1f1f1};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props: any) => props.theme.colors.cc1c1c1};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${(props: any) => props.theme.colors.ca8a8a8};
  }
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(props: any) => props.theme.colors.white};
  border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
  border-radius: 8px;
  padding: 12px 16px;
  height: 48px;
  box-sizing: border-box;
`;

export const FileName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
  flex-shrink: 1;
`;

export const AddFilesButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  border-radius: 6px;
  border: 2px dashed ${(props: any) => props.theme.colors.primaryRed400};
  cursor: pointer;
  background: ${(props: any) => props.theme.colors.white};
  color: ${(props: any) => props.theme.colors.primaryRed400};
  font-weight: 500;
  font-size: 14px;
  width: 100%;
  padding: 0 16px;
  margin-bottom: 16px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  outline: none;

  &:hover {
    background: ${(props: any) => props.theme.colors.cfff7f8};
    border-color: ${(props: any) => props.theme.colors.cd32f2f};
  }

  &:active {
    background: ${(props: any) => props.theme.colors.cffe5e8};
  }

  &:focus {
    outline: 2px solid ${(props: any) => props.theme.colors.primaryRed400};
    outline-offset: 2px;
  }
`;

export const HiddenFileInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background-color: transparent;
  color: ${(props: any) => props.theme.colors.ce53e3e};
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background-color: ${(props: any) => props.theme.colors.cfde8e8};
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 16px;
    height: 16px;
    
    path {
      fill: ${(props: any) => props.theme.colors.ce53e3e};
    }
  }
`;

export const DateTimeContainer = styled.div`
  display: flex;
  gap: 0;
  align-items: flex-end;
  width: 100%;
  height: 48px;
`;

export const DatePickerContainer = styled.div`
  flex: 1;
  width: 100%;
  
  input {
    box-sizing: border-box !important;
    width: 100% !important;
    height: 48px !important;
    border-radius: 8px 0px 0px 8px !important;
    border-right: none !important;
  }
  
  input {
    &:hover {
      border: 1px solid ${(props: any) => props.theme.colors.c000000} !important;
      border-right: 1px solid ${(props: any) => props.theme.colors.c000000} !important;
    }
    
    &:focus {
      border: 1px solid ${(props: any) => props.theme.colors.c000000} !important;
      border-right: 1px solid ${(props: any) => props.theme.colors.c000000} !important;
    }
  }
`;

export const TimezoneReadonly = styled.div`
  box-sizing: border-box;
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  height: 48px;
  border-radius: 0px 8px 8px 0px;
  border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
  border-left: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props: any) => props.theme.colors.interfaceText500};
  font-size: 16px;
  font-weight: 600;
  user-select: none;
`;

export const LoadingFileRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(props: any) => props.theme.colors.white};
  border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
  border-radius: 8px;
  padding: 12px 16px;
  height: 48px;
  box-sizing: border-box;
  margin-bottom: 8px;
  position: relative;
  overflow: hidden;
`;

export const LoadingFileInfo = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex: 1;
  min-width: 0;
`;

export const LoadingFileName = styled.div`
  color: ${(props: any) => props.theme.colors.c1a202c};
  font-size: 14px;
  font-weight: 400;
  animation: pulse 1.5s ease-in-out infinite;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
  flex-shrink: 1;
`;

export const LoadingFileSize = styled.div`
  color: ${(props: any) => props.theme.colors.c6b7280};
  font-size: 12px;
  animation: pulse 1.5s ease-in-out infinite;
`;

export const LoadingSpinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`;

export const Spinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid ${(props: any) => props.theme.colors.ce2e8f0};
  border-top: 2px solid ${(props: any) => props.theme.colors.primaryRed400};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const PulseAnimation = styled.div`
  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;

